// extracted by mini-css-extract-plugin
export default {"content":"AdvancedPlanInfoCard_content__oUFVC","title":"AdvancedPlanInfoCard_title__WUpEw"};